import Doubt from "api/lib/abstract_query/interfaces/Doubt";
import Analysis from "api/lib/data/Analysis";
import MessageObject from "api/lib/data/interfaces/MessageObject";
import MessageType from "api/lib/data/interfaces/MessageType";
import * as _ from "lodash";
import * as React from "react";
import { Comment, Segment } from "semantic-ui-react";
import { Base, Event, IBaseProps, IBaseState } from "../Common/Base";
import Message from "./Message";
import MessageForm from "./MessageForm";
import Skeleton from "./Skeleton";

export interface IBotSightsProps extends IBaseProps {
  authUser: any;
  analysis: Analysis;
  datasourceMetadata: any;
  doubts: Doubt[];
  messageType: MessageType;
  onAddMessage: (message: string) => void;
  onVersionChange: (versionId) => void;
  onClearQuery: () => void;
}

export interface IBotSightsState extends IBaseState {
  botsights: MessageObject[];
  messagesLoading: boolean;
  searchTerm: string;
  searchLoading: boolean;
  searchResults: any[];
}

export default class BotSights extends Base<IBotSightsProps, IBotSightsState> {
  private static INITIAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    botsights: [],
    messagesLoading: true,
    searchLoading: false,
    searchResults: [],
    searchTerm: "",
  };
  private messagesEnd: any;
  constructor(props: IBotSightsProps) {
    super(props);
    this.messagesEnd = this.messagesEnd || undefined;
    this.state = { ...BotSights.INITIAL_STATE };
  }

  public render() {
    const {
      messagesLoading,
      searchTerm,
      searchResults,
      botsights,
    } = this.state;
    return (
      <React.Fragment>
        <Segment
          style={{
            height:
              this.props.messageType === MessageType.U2B
                ? "100%"
                : "calc(100% - 72px)",
          }}
        >
          {/* <Input
            fluid={true}
            loading={searchLoading}
            onChange={this.handleSearchChange}
            size="mini"
            icon="search"
            name="searchTerm"
            placeholder="Search Messages"
          /> */}
          <Comment.Group
            className={`messages ${
              this.props.messageType === MessageType.U2B ? "activity" : ""
            }`}
          >
            <div ref={(node) => (this.messagesEnd = node)} />
            {this.displayMessageSkeleton(messagesLoading)}
            {searchTerm
              ? this.displayMessages(searchResults)
              : this.displayMessages(botsights)}
          </Comment.Group>
        </Segment>
        {this.props.messageType === MessageType.U2U && (
          <MessageForm
            doubts={this.props.doubts}
            metadata={this.props.datasourceMetadata}
            value=""
            onChange={this.props.onAddMessage}
            onClearQuery={this.props.onClearQuery}
          />
        )}
      </React.Fragment>
    );
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };

  public componentDidMount = () => {
    this.getData(this.props.analysis, this.props.messageType);
  };

  public componentDidUpdate = (prevProps: IBotSightsProps, prevState) => {
    if (
      this.props.analysis !== prevProps.analysis ||
      this.props.messageType !== prevProps.messageType
    ) {
      const { analysis, messageType } = this.props;
      this.getData(analysis, messageType);
    }
  };

  private displayMessages = (messages: MessageObject[]) => {
    if (messages.length > 0) {
      // if (this.props.messageType === MessageType.U2U) {
      //   messages = messages.reverse();
      // }

      return messages.map(
        (message: MessageObject) =>
          message.audit && (
            <Message
              key={(message.audit.createdAt as any) as number}
              message={message}
              showVersion={this.props.onVersionChange}
            />
          )
      );
    }
  };

  private displayMessageSkeleton = (loading: boolean) =>
    loading ? (
      <React.Fragment>
        {[...Array(10)].map((o, i) => (
          <Skeleton key={i} />
        ))}
      </React.Fragment>
    ) : null;

  // private handleSearchChange = (event: any) => {
  //   this.setState(
  //     {
  //       searchLoading: true,
  //       searchTerm: event.target.value,
  //     },
  //     () => this.handleSearchMessages()
  //   );
  // };

  // private handleSearchMessages = () => {
  //   const botsights = [...this.state.botsights];
  //   const regex = new RegExp(this.state.searchTerm, "gi");
  //   const searchResults = botsights.reduce((acc, message) => {
  //     if (
  //       (message.content && message.content.match(regex)) ||
  //       message.user.name.match(regex)
  //     ) {
  //       acc.push(message);
  //     }
  //     return acc;
  //   }, []);
  //   this.setState({ searchResults });
  //   setTimeout(() => this.setState({ searchLoading: false }), 1000);
  // };

  private getData = (analysis: Analysis, messageType: MessageType) => {
    this.getListner(
      analysis.getMessages(),
      Event.Value,
      (snapshot: firebase.database.DataSnapshot) => {
        const dataObj: any = snapshot.val();
        if (dataObj) {
          const botsights: MessageObject[] = Object.keys(dataObj).map((id) => {
            const botsight: MessageObject = dataObj[id];
            return botsight;
          });
          // const filteredBotsights = _.filter(botsights, (b) => {
          //   return b.type === messageType;
          // });
          // if (this.props.messageType === MessageType.U2U) {
          //   this.setState(
          //     { botsights: filteredBotsights, messagesLoading: false },
          //     () => {
          //       this.scrollToBottom();
          //     }
          //   );
          // } else {
          this.setState({
            botsights: botsights.reverse(),
            messagesLoading: false,
          });
          // }
        } else {
          this.setState({
            botsights: [],
            messagesLoading: false,
          });
        }
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Query/BotSights.tsx